import { Button } from '@platform/components';
import BottomLeftImg from './svgs/bottom-left.jpg';
import BottomMidImg from './svgs/bottom-mid.jpg';
import BottomRightImg from './svgs/bottom-right.png';
import TopLeftImg from './svgs/top-left.png';
import TopRightImg from './svgs/top-right.png';

const PartnerLandingAboutSection = ({ signUpUrl }: { signUpUrl: string }) => (
  <section className="bg-white py-16 sm:py-20 px-4 sm:px-8">
    <div className="max-w-[1216px] mx-auto">
      <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">

        {/* LEFT TEXT */}
        <div className="lg:w-1/2 flex flex-col">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight tracking-[-0.02em] text-gray-700">
            About MovingWorlds
          </h2>

          <p className="mt-6 text-lg text-gray-500 leading-7 max-w-xl">
            MovingWorlds is a global capacity-building platform and partnership network that connects
            companies, professionals, and social enterprises to share skills, learn and grow
            together, and create measurable social and environmental impact.
          </p>

          <div className="mt-8 w-full sm:w-fit">
            <Button variant="primary" size="xl" href={signUpUrl} additionalClassnames="w-full sm:w-auto">
              Sign up
            </Button>
          </div>
        </div>

        {/* IMAGE COLLAGE */}
        <div className="lg:w-1/2 w-full flex flex-col items-center gap-4">

          {/* TOP ROW */}
          <div className="flex gap-4 items-end">
            <div className="overflow-hidden">
              <img
                src={TopLeftImg}
                className="w-[160px] h-[160px] object-cover"
              />
            </div>

            <div className="overflow-hidden">
              <img
                src={TopRightImg}
                className="w-[160px] h-[240px] object-cover"
              />
            </div>
          </div>

          {/* BOTTOM ROW */}
          <div className="flex gap-4">
            <div className="overflow-hidden">
              <img
                src={BottomLeftImg}
                className="w-[192px] h-[128px] object-cover"
              />
            </div>

            <div className="overflow-hidden">
              <img
                src={BottomMidImg}
                className="w-[160px] h-[240px] object-cover"
              />
            </div>

            <div className="overflow-hidden">
              <img
                src={BottomRightImg}
                className="w-[192px] h-[128px] object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default PartnerLandingAboutSection;